import IconButton from 'components/atoms/button/IconButton';
import withModal from 'lib/helpers/hoc/withModal'
import { useDeleteTeam } from 'lib/hooks/mutations/Settings/useDeleteTeam';
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next';

interface DeleteTeamProps {
    id: string;
    type: string;
    onConfirm: () => void;
}

const DeleteTeam: FC<DeleteTeamProps> = ({ id, onConfirm, type }) => {
    const { t } = useTranslation();

    const { mutateAsync: deleteTeam, isLoading } = useDeleteTeam(type === 'broker')
    const handleDelete = () => {
        deleteTeam({ team_id: id }).then(() => {
            onConfirm()
        })
    }

    return (
        <div className='flex flex-col gap-10'>
            <div className='font-inter-medium text-xl text-primaryTextColor'>
                This action cannot be undone. All team members will be affected. If you're not sure, consider deactivating the team instead.
            </div>
            <div className="flex gap-4 justify-end">
                <IconButton
                    secondary={true}
                    type="button"
                    onClick={() => { onConfirm() }}
                    disabled={isLoading}

                >
                    {t("Cancel")}
                </IconButton>
                <IconButton
                    disabled={isLoading}
                    type="button"
                    onClick={handleDelete}
                >
                    {t("Delete")}
                </IconButton>
            </div>
        </div>
    )
}

export default withModal(DeleteTeam)